import React from 'react'

const Tableau = () => {
  return (
    <div>
        {/* collapseFiftyFive */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftyFive">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyFive" aria-expanded="false" aria-controls="collapseFiftyFive">
                    Tableau <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftyFive" className="accordion-collapse collapse" aria-labelledby="headingFiftyFive" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Module 1: Tableau Course Material</strong>
                    <ul>
                        <li>Start Page</li>
                        <li>Show Me</li>
                        <li>Connecting to Excel Files</li>
                        <li>Connecting to Text Files</li>
                        <li>Connect to Microsoft SQL Server</li>
                        <li>Connecting to Microsoft Analysis Services</li>
                        <li>Creating and Removing Hierarchies</li>
                        <li>Bins</li>
                        <li>Joining Tables</li>
                        <li>Data Blending</li>
                    </ul>

                    <strong>Module 2: Learn Tableau Basic Reports</strong>
                    <ul>
                        <li>Arameters</li>
                        <li>Grouping Example 1</li>
                        <li>Grouping Example 2</li>
                        <li>Edit Groups</li>
                        <li>Set</li>
                        <li>Combined Sets</li>
                        <li>Creating a First Report</li>
                        <li>Data Labels</li>
                        <li>Create Folders</li>
                        <li>Sorting Data</li>
                        <li>Add Totals, Subtotals and Grand Totals to Report</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Install Tableau Desktop</li>
                        <li>Connect Tableau to various Datasets: Excel and CSV files</li>
                    </ul>

                    <strong>Module 3: Learn Tableau Charts</strong>
                    <ul>
                        <li>Area Chart</li>
                        <li>Bar Chart</li>
                        <li>Box Plot</li>
                        <li>Bubble Chart</li>
                        <li>Bump Chart</li>
                        <li>Bullet Graph</li>
                        <li>Circle Views</li>
                        <li>Dual Combination Chart</li>
                        <li>Dual Lines Chart</li>
                        <li>Funnel Chart</li>
                        <li>Traditional Funnel Charts</li>
                        <li>Gantt Chart</li>
                        <li>Grouped Bar or Side by Side Bars Chart</li>
                        <li>Heatmap</li>
                        <li>Highlight Table</li>
                        <li>Histogram</li>
                        <li>Cumulative Histogram</li>
                        <li>Line Chart</li>
                        <li>Lollipop Chart</li>
                        <li>Pareto Chart</li>
                        <li>Pie Chart</li>
                        <li>Scatter Plot</li>
                        <li>Stacked Bar Chart</li>
                        <li>Text Label</li>
                        <li>Tree Map</li>
                        <li>Word Cloud</li>
                        <li>Waterfall Chart</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Create and use Static Sets</li>
                        <li>Create and use Dynamic Sets</li>
                        <li>Combine Sets into more Sets</li>
                        <li>Use Sets as filters</li>
                        <li>Create Sets via Formulas</li>
                        <li>Control Sets with Parameters</li>
                        <li>Control Reference Lines with Parameters</li>
                    </ul>

                    <strong>Module 4: Learn Tableau Advanced Reports</strong>
                    <ul>
                        <li>Dual Axis Reports</li>
                        <li>Blended Axis</li>
                        <li>Individual Axis</li>
                        <li>Add Reference Lines</li>
                        <li>Reference Bands</li>
                        <li>Reference Distributions</li>
                        <li>Basic Maps</li>
                        <li>Symbol Map</li>
                        <li>Use Google Maps</li>
                        <li>Mapbox Maps as a Background Map</li>
                        <li>WMS Server Map as a Background Map</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Create Barcharts</li>
                        <li>Create Area Charts</li>
                        <li>Create Maps</li>
                        <li>Create Interactive Dashboards</li>
                        <li>Create Storylines</li>
                        <li>Understand Types of Joins and how they work</li>
                        <li>Work with Data Blending in Tableau</li>
                        <li>Create Table Calculations</li>
                        <li>Work with Parameters</li>
                        <li>Create Dual Axis Charts</li>
                        <li>Create Calculated Fields</li>
                    </ul>

                    <strong>Module 5: Learn Tableau Calculations & Filters</strong>
                    <ul>
                        <li>Calculated Fields</li>
                        <li>Basic Approach to Calculate Rank</li>
                        <li>Advanced Approach to Calculate Ra</li>
                        <li>Calculating Running Total</li>
                        <li>Filters Introduction</li>
                        <li>Quick Filters</li>
                        <li>Filters on Dimensions</li>
                        <li>Conditional Filters</li>
                        <li>Top and Bottom Filters</li>
                        <li>Filters on Measures</li>
                        <li>Context Filters</li>
                        <li>Slicing Fliters</li>
                        <li>Data Source Filters</li>
                        <li>Extract Filters</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Creating Data Extracts in Tableau</li>
                        <li>Understand Aggregation, Granularity, and Level of Detail</li>
                        <li>Adding Filters and Quick Filters</li>
                    </ul>

                    <strong>Module 6: Learn Tableau Dashboards</strong>
                    <ul>
                        <li>Create a Dashboard</li>
                        <li>Format Dashboard Layout</li>
                        <li>Create a Device Preview of a Dashboard</li>
                        <li>Create Filters on Dashboard</li>
                        <li>Dashboard Objects</li>
                        <li>Create a Story</li>
                    </ul>

                    <strong>Module 7: Server</strong>
                    <ul>
                        <li>Tableau online</li>
                        <li>Overview of Tableau</li>
                        <li>Publishing Tableau objects and scheduling/subscription.</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Create Data Hierarchies</li>
                        <li>Adding Actions to Dashboards (filters & highlighting)</li>
                        <li>Assigning Geographical Roles to Data Elements</li>
                        <li>Advanced Data Preparation</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Tableau